var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('sy-baselist',{attrs:{"hideAdd":"","hideOperate":"","listUrl":"server/system/System.ashx?cmd=GetSysInfo"}},[_c('el-table-column',{attrs:{"prop":"name","label":"名称","width":"250","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":"状态","width":"150","sortable":""}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b3fe64f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/system/SystemInfo.vue
// module id = null
// module chunks = 